export { ChipUSPs } from './ChipUsps';
